module.exports = __webpack_public_path__ + "img/antiSandBox_checked.4cb7d545.png";